import { ROUTES, PATHS } from "@config/app.routing";

import { AVAILABLE_LANGS } from "@typings/globals";

import { BroomCircle, UserProfileCircle } from "@ui/Assets/MyIcons";

import { TranslateFunction } from "@hooks/useTranslate";

import { Link } from "./useAccountNav.types";

export const getLinks = (
  language: AVAILABLE_LANGS,
  translate: TranslateFunction,
): Link[] => [
  // CLIENT LINKS
  {
    icon: BroomCircle,
    label: translate("batmaid_pwa_navigation.subnav_my_cleaning"),
    href: `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_MY_CLEANINGS}`,
    hrefSSG: `/${language}${PATHS.CLIENT_APP}#${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_MY_CLEANINGS}`,
    testId: "myCleaning",
    eventId: "my-cleaning-header",
    hiddenFor: "agent",
  },
  {
    icon: UserProfileCircle,
    label: translate("batmaid_pwa_navigation.subnav_profile"),
    href: `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_PROFILE}`,
    hrefSSG: `/${language}${PATHS.CLIENT_APP}#${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_PROFILE}`,
    testId: "profile",
    eventId: "profile-header",
    hiddenFor: "agent",
  },

  // AGENT LINKS
  {
    label: translate("batmaid_pwa_navigation.subnav_agent_schedule"),
    href: ROUTES.AGENT_SCHEDULE,
    hrefSSG: `/${language}${PATHS.AGENT_APP}#${ROUTES.AGENT_SCHEDULE}`,
    testId: "agentSchedule",
    eventId: "agent-schedule-header",
    hiddenFor: "client",
  },
  {
    label: translate("batmaid_pwa_navigation.subnav_agent_my_cleanings"),
    href: ROUTES.AGENT_MY_CLEANINGS,
    hrefSSG: `/${language}${PATHS.AGENT_APP}#${ROUTES.AGENT_MY_CLEANINGS}`,
    testId: "agentMyCleanings",
    eventId: "agent-my-cleanings-header",
    hiddenFor: "client",
  },
  {
    label: translate("batmaid_pwa_navigation.subnav_agent_new_cleanings"),
    href: ROUTES.AGENT_NEW_CLEANINGS,
    hrefSSG: `/${language}${PATHS.AGENT_APP}#${ROUTES.AGENT_NEW_CLEANINGS}`,
    testId: "agentNewCleanings",
    eventId: "agent-new-cleanings-header",
    hiddenFor: "client",
  },
  {
    label: translate("batmaid_pwa_navigation.subnav_agent_availabilities"),
    href: ROUTES.AGENT_AVAILABILITIES,
    hrefSSG: `/${language}${PATHS.AGENT_APP}#${ROUTES.AGENT_AVAILABILITIES}`,
    testId: "agentAvailabilities",
    eventId: "agent-availabilities-header",
    hiddenFor: "client",
  },
  {
    label: translate("batmaid_pwa_navigation.subnav_agent_profile"),
    href: ROUTES.AGENT_PROFILE,
    hrefSSG: `/${language}${PATHS.AGENT_APP}#${ROUTES.AGENT_PROFILE}`,
    testId: "agentProfile",
    eventId: "agent-profile-header",
    hiddenFor: "client",
  },
];
